module.exports = __webpack_public_path__ + "0ad8165b10c35d6a6227f1409210857b.pdf";